/**
 * Address model for mobile client
 * Represents a user's address information
 */
class Address {
  constructor({
    AddressID = null,
    UserId = null,
    Country = '',
    States = '',
    Province = '',
    City = '',
    Address = '',
    LineTwo = '',
    ZIP = '',
    Type = 'home',
    CreatedAt = null,
    UpdatedAt = null,
  } = {}) {
    this.AddressID = AddressID;
    this.UserId = UserId;
    this.Country = Country;
    this.States = States;
    this.Province = Province;
    this.City = City;
    this.Address = Address;
    this.LineTwo = LineTwo;
    this.ZIP = ZIP;
    this.Type = Type;
    this.CreatedAt = CreatedAt ? new Date(CreatedAt) : new Date();
    this.UpdatedAt = UpdatedAt ? new Date(UpdatedAt) : new Date();
  }

  /**
   * Get formatted full address as a string
   * @returns {string} Formatted address
   */
  getFormattedAddress() {
    const parts = [
      this.Address,
      this.LineTwo,
      this.City,
      this.States || this.Province,
      this.ZIP,
      this.Country
    ];
    return parts.filter(part => part && part.trim() !== '').join(', ');
  }

  /**
   * Factory method to create an Address instance from API response
   * @param {Object} data - Raw address data from API
   * @returns {Address} - Instantiated Address object
   */
  static fromAPI(data) {
    return new Address({
      AddressID: data.AddressID,
      UserId: data.UserId,
      Country: data.Country,
      States: data.States,
      Province: data.Province,
      City: data.City,
      Address: data.Address,
      LineTwo: data.LineTwo,
      ZIP: data.ZIP,
      Type: data.Type,
      CreatedAt: data.CreatedAt,
      UpdatedAt: data.UpdatedAt,
    });
  }

  /**
   * Convert Address instance to plain object (for storage, etc.)
   * @returns {Object} Plain JavaScript object
   */
  toJSON() {
    return {
      AddressID: this.AddressID,
      UserId: this.UserId,
      Country: this.Country,
      States: this.States,
      Province: this.Province,
      City: this.City,
      Address: this.Address,
      LineTwo: this.LineTwo,
      ZIP: this.ZIP,
      Type: this.Type,
      CreatedAt: this.CreatedAt.toISOString(),
      UpdatedAt: this.UpdatedAt.toISOString(),
    };
  }
}

export default Address;
